/**
 * @module config/env
 * @description Centralized, type-safe environment configuration with robust fallbacks.
 * Adheres to OWASP and lead-react-engineer standards.
 */

export const APP_NAME: string =
  process.env.REACT_APP_APP_NAME || "RxDeviceGateway";

export const ORG_NAME: string =
  process.env.REACT_APP_ORG_NAME || "Roborosx Omni Tech Solutions LLP";

export const ORG_SUPPORT_EMAIL: string =
  process.env.REACT_APP_ORG_SUPPORT_EMAIL || "support@roborosx.com";

export const ORG_PRIVACY_EMAIL: string =
  process.env.REACT_APP_ORG_PRIVACY_EMAIL || "privacy@roborosx.com";

export const APP_DESCRIPTION: string =
  process.env.REACT_APP_APP_DESCRIPTION ||
  "Enterprise IoT Edge & Device Management Platform";

export const PORTAL_TITLE: string =
  process.env.REACT_APP_PORTAL_TITLE || "Super Admin Portal";

const rawBaseUrl: string = (
  process.env.REACT_APP_API_BASE_URL || "http://localhost:5201/api/v1"
)
  .trim()
  .replace(/\/+$/, "");

// Guarantees base URL is generic for both client and super-admin (e.g. /api/v1 or https://gateway.syncdevice.io/api/v1)
// and eliminates any lingering /super-admin suffix from old environment variables.
export const API_BASE_URL: string = rawBaseUrl.replace(/\/super-admin$/, "");

export const APP_VERSION: string =
  process.env.REACT_APP_VERSION || "v1.0.0";
